import React from 'react';
import PropTypes from 'prop-types';

import { Button, Icons, PlaceholderText } from 'sarsaparilla';

export default function BackToLink({ isLoading, backTo = '', ...rest }) {
    if (isLoading) {
        return <PlaceholderText fontSize={12} lineHeight={20.4} width="25rem" />;
    }
    return (
        <Button
            data-shared-back-to-search-button
            appearance="link"
            iconBeforeElement={<Icons.IconArrowBack />}
            role="link"
            {...rest}
        >
            {`Back to ${backTo}`}
        </Button>
    );
}

BackToLink.propTypes = {
    isLoading: PropTypes.bool,
    backTo: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};
